module.exports = __webpack_public_path__ + "zilla-slab-latin-700.aefbe7f15bb93ada7eabd3cac3f81651.woff2";